import { fit } from './fit';

export const contain = fit(true);
